import queryString from 'query-string';
import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

export const clearSearchedCompanies = () => (dispatch) => {
    dispatch({
        type: ACTIONS.CLEAR_SEARCHED_COMPANIES
    });
};

export const getManyCompanies = (params, actionType = ACTIONS.GET_MANY_COMPANIES) => (dispatch) => {
    const { pathsContext, ...rest } = params;
    let newQuery;
    if (rest && Array.isArray(rest._id)) {
        newQuery = `_id=${rest._id.filter(Boolean).join(',')}`;
    } else {
        newQuery = queryString.stringify(rest);
    }
    const url = `${pathsContext.adminServerUrl}/companies?${newQuery}`;

    return VerbFetch(url).then((body) => {
        dispatch({
            type: actionType,
            payload: {
                companies: body
            }
        });
        return body;
    });
};

export const getFilteredCompanies = (params) => getManyCompanies(params, ACTIONS.GET_FILTERED_COMPANIES);

export const getCompanyByPermalink = (params) => (dispatch) => {
    const {pathsContext, permalink} = params
    const url = `${pathsContext.serverUrl}/companies/permalink/${permalink}`;
    return VerbFetch(url).then((retrievedCompany) => {
        dispatch({
            type: ACTIONS.GET_COMPANY,
            payload: {
                company: retrievedCompany
            }
        });

        return retrievedCompany;
    });
};

/**
 *
 * @param {Object} params
 * @param {String} params.companyId
 * @return {function(*)}
 */
export const getCompany = (params) => {
    const { companyId, dispatchDisabled, pathsContext, queryParams = {} } = params;
    const url = `${pathsContext.serverUrl}/companies/${companyId}`;
    const urlWithParams = buildQueryString(queryParams, url);
    if (dispatchDisabled) {
        return VerbFetch(urlWithParams);
    }
    return (dispatch) =>
        VerbFetch(urlWithParams).then((companyBody) => {
            dispatch({
                type: ACTIONS.GET_COMPANY,
                payload: {
                    company: companyBody
                }
            });

            return companyBody;
        });
};

export const postCompany = (params) => {
    const { body, pathsContext } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.POST_COMPANY_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/companies`, {
            method: 'POST',
            body
        }).then((result) => {
            dispatch({
                type: ACTIONS.POST_COMPANY_SUCCESS,
                payload: {
                    company: result
                }
            });

            return result;
        });
    };
};

export const putCompany = (params) => {
    const { companyId, body, pathsContext } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_COMPANY_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/companies/${companyId}`, {
            method: 'PUT',
            body
        }).then((result) => {
            dispatch({
                type: ACTIONS.PUT_COMPANY_SUCCESS,
                payload: {
                    company: result
                }
            });
            return result;
        });
    };
};

export const getCompanyMemberProfiles = (params) => {
    const { companyId, dispatchDisabled, limit, page, sortBy, pathsContext } = params;
    const baseUrl = `${pathsContext.serverUrl}/companies/${companyId}/members`;
    const queryParams = { limit, page, sortBy };
    const url = buildQueryString(queryParams, baseUrl);

    if (dispatchDisabled) {
        return VerbFetch(url);
    }

    return (dispatch) =>
        VerbFetch(url).then((companyMemberProfiles) => {
            dispatch({
                type: ACTIONS.GET_COMPANY_MEMBERS,
                payload: {
                    profiles: companyMemberProfiles,
                    companyId
                }
            });

            return companyMemberProfiles;
        });
};

export const putCompanyMembers = (params) => {
    const { companyId, action, membersToUpdate, pathsContext } = params;
    let actions;
    if (action === 'add') {
        actions = [ACTIONS.ADD_COMPANY_MEMBERS_START, ACTIONS.ADD_COMPANY_MEMBERS_SUCCESS];
    } else if (action === 'remove') {
        actions = [ACTIONS.REMOVE_COMPANY_MEMBERS_START, ACTIONS.REMOVE_COMPANY_MEMBERS_SUCCESS];
    }

    return (dispatch) => {
        dispatch({
            type: actions[0],
            payload: {
                body: membersToUpdate
            }
        });
        const url = `${pathsContext.adminServerUrl}/companies/${companyId}/members`;
        return VerbFetch(url, {
            method: 'PUT',
            body: {
                membersToUpdate,
                action
            }
        }).then((memberProfiles) => {
            dispatch({
                type: actions[1],
                payload: {
                    profiles: memberProfiles
                }
            });
        });
    };
};

export const getCompanyPaymentInfo = (params) => {
    const { companyId, pathsContext } = params;

    return () =>
        VerbFetch(`${pathsContext.adminServerUrl}/companies/${companyId}/paymentinfo`, {
            method: 'GET'
        }).then((result) => result);
};

export const updateCompanyPaymentInfo = (params) => {
    const { companyId, tokenOrSource, pathsContext } = params;

    return (dispatch) =>
        VerbFetch(`${pathsContext.adminServerUrl}/companies/${companyId}/paymentinfo`, {
            method: 'PUT',
            body: { tokenOrSource }
        }).then((result) => {
            dispatch({
                type: ACTIONS.UPDATE_COMPANY_PAYMENT_INFO,
                payload: {
                    company: result
                }
            });

            return result;
        });
};

export const getCompanyGrowthMetrics = (params) => {
    const { companyId, pathsContext } = params;
    return VerbFetch(`${pathsContext.serverUrl}/companies/${companyId}/growthmetrics`).then((result) => result);
};

export const getCompanyByName = (params) => {
    const { companyName, pathsContext } = params;
    return (dispatch) =>
        VerbFetch(`${pathsContext.serverUrl}/companies/namesearch/${companyName}`).then((companyBody) => {
            if (companyBody) {
                dispatch({
                    type: ACTIONS.GET_COMPANY,
                    payload: {
                        company: companyBody
                    }
                });
            }
            return companyBody;
        });
};

export const postSearchedCompanyMemberProfiles = (params) => {
    const { pathsContext, ...rest } = params;
    const url = `${pathsContext.serverUrl}/userprofiles/search`;
    return (dispatch) =>
        VerbFetch(url, {
            method: 'POST',
            body: rest
        }).then((results) => {
            dispatch({
                type: ACTIONS.GET_MANY_PROFILES,
                payload: {
                    profiles: results
                }
            });
            return results;
        });
};
